import styles from "./toastScreenleft.module.scss";
import nodata from "../../../../styles/images/nosmall.svg";
import React from 'react';
export default function ChatToastLeft() {

  return (
    <>
      {/* <div className={styles.toastScreenleft}>
        <img src={nodata} alt="" />
        <span className="">1 message unsaved</span>
        <span className={styles.undoButton}>Undo</span>
        <span className="icon_close"></span>
      </div> */}
      <div className={styles.noInternetCon}>
        <img src={nodata} alt="" />
        <span className="">Hmmm, you are not Connected</span>
        {/* <span className={styles.undoButton}>Undo</span> */}
        <span className="icon_close"></span>
      </div>
    </>
  );
};

